// src/js/behaviour/contact-form.js

export default function initContactForms(root = document) {
  console.log("INIT CONTACT FORMS RUNNING");

  const triggers = root.querySelectorAll('[data-module="contact-form"]');

  console.log("CONTACT FORM TRIGGERS:", triggers);

  ensureModalExists();

  const modal = document.getElementById("sz-contact-form-modal");

  const iframe = modal.querySelector(".sz-contact-form-modal__iframe");

  const closeButtons = modal.querySelectorAll("[data-close-modal]");

  let activeTrigger = null;

  /* -----------------------------------------
OPEN
----------------------------------------- */

  triggers.forEach((trigger) => {
    if (trigger.dataset.contactFormInitialised === "true") {
      return;
    }

    trigger.dataset.contactFormInitialised = "true";

    trigger.addEventListener("click", () => {
      console.log("CONTACT BUTTON CLICKED");

      activeTrigger = trigger;

      const email = trigger.dataset.contactEmail || "";

      const geckoOverride = trigger.dataset.geckoForm || "";

      let iframeSrc = "";

      if (geckoOverride) {
        iframeSrc = geckoOverride;
      } else {
        iframeSrc =
          "https://app.geckoform.com/public/#/modern/Ujmtl4sW1x60cYFE" +
          "?altEmail=" +
          encodeURIComponent(email);
      }

      iframe.setAttribute("src", iframeSrc);

      openModal(modal);
    });
  });

  /* -----------------------------------------
CLOSE BUTTONS
----------------------------------------- */

  closeButtons.forEach((button) => {
    button.addEventListener("click", () => {
      closeModal(modal, iframe, activeTrigger);
    });
  });

  /* -----------------------------------------
OVERLAY CLOSE
----------------------------------------- */

  modal.addEventListener("click", (event) => {
    if (event.target === modal) {
      closeModal(modal, iframe, activeTrigger);
    }
  });

  /* -----------------------------------------
ESC CLOSE
----------------------------------------- */

  document.addEventListener("keydown", (event) => {
    if (event.key === "Escape" && modal.classList.contains("is-open")) {
      closeModal(modal, iframe, activeTrigger);
    }
  });
}

/* -----------------------------------------
OPEN MODAL
----------------------------------------- */

function openModal(modal) {
  modal.setAttribute("aria-hidden", "false");

  modal.classList.add("is-open");

  document.documentElement.classList.add("is-modal-open");
document.body.classList.add("is-modal-open");
}

/* -----------------------------------------
CLOSE MODAL
----------------------------------------- */

function closeModal(modal, iframe, activeTrigger) {
  modal.classList.remove("is-open");

  modal.setAttribute("aria-hidden", "true");

  iframe.setAttribute("src", "");

  document.documentElement.classList.remove("is-modal-open");
document.body.classList.remove("is-modal-open");

  if (activeTrigger) {
    activeTrigger.focus();
  }
}

/* -----------------------------------------
CREATE MODAL
----------------------------------------- */

function ensureModalExists() {
  if (document.getElementById("sz-contact-form-modal")) {
    return;
  }

  const modal = document.createElement("div");

  modal.id = "sz-contact-form-modal";

  modal.className = "sz-contact-form-modal";

  modal.setAttribute("aria-hidden", "true");
  modal.innerHTML = `
<div class="sz-contact-form-modal__dialog">
  <div class="sz-contact-form-modal__header">
  
    <h2
      class="sz-contact-form-modal__title"
      id="sz-contact-form-modal-title"
    >
      Contact form
    </h2>
  
    <button
      class="sz-contact-form-modal__close"
      type="button"
      aria-label="Close contact form"
      data-close-modal
    >
      ×
    </button>
  
  </div>
  
  <div class="sz-contact-form-modal__body">
  
    <iframe
      class="sz-contact-form-modal__iframe"
      src=""
      title="Contact form"
      loading="lazy"
    ></iframe>
  
  </div>
</div>
`;

  document.body.appendChild(modal);
}
